import { ApiRequestError } from "./apiRequest";

/** Best-effort human-readable message from any thrown value. */
export function errorMessage(err: unknown, fallback = "Something went wrong"): string {
  if (err instanceof ApiRequestError) return err.message;
  if (err instanceof Error) return err.message;
  return fallback;
}

/** The admin error code, if the error came from the API. */
export function errorCode(err: unknown): string | undefined {
  return err instanceof ApiRequestError ? err.code : undefined;
}
